import { colors } from '@styles/vars/colors.style'
import styled from 'styled-components'

export const VideoModalMain = styled.div`
  position: relative;
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
`

export const VideoModalWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${colors.charcoal};

  iframe {
    width: 100%;
    height: 100%;
  }
`

export const VideoModalClose = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  padding: 1.354166667vw 2.083333333vw;
  color: ${colors.white};
  background: none;
  border: none;
  &:focus-visible {
    outline: unset;
  }
  &:focus {
    outline: unset;
  }
`
